import api from "./index"

export const registerUser = (username, email, phone_number, password) =>
  api.post("/auth/register", { username, email, phone_number, password })

export const verifyEmail = (email, code) =>
  api.post("/auth/verify-email", { email, code })

export const resendEmailVerification = (email) =>
  api.post("/auth/resend-email-verification", null, { params: { email } })

export const verifyPhone = (email, code) =>
  api.post("/auth/verify-phone", { email, code })

export const resendPhoneVerification = (email) =>
  api.post("/auth/resend-phone-verification", null, { params: { email } })

// Step 1 of login: returns { challenge_id, expires_in, trusted_device }.
// If trusted_device is true, the cookie is already set
export const loginUser = (username, password) =>
  api.post("/auth/login", { username, password })

// Step 2 of login: sets the cookie(s) and returns the user
export const verifyLoginOtp = (challenge_id, code, trust_device = false) =>
  api.post("/auth/verify-phone-otp", { challenge_id, code, trust_device })

// Re-sends the login code for an existing challenge
export const resendLoginOtp = (challenge_id) =>
  api.post("/auth/resend-login-otp", { challenge_id })

export const logoutUser = () => api.post("/auth/logout")

export const getCurrentUser = () => api.get("/auth/me")
